// extracted by mini-css-extract-plugin
export default {"toggle":"Toggle_toggle__XU30h","knob":"Toggle_knob__lZFnR","on":"Toggle_on__DpgI-","mixed":"Toggle_mixed__8CRtq","dash":"Toggle_dash__xX749","label":"Toggle_label__YmDee"};